/**
 * @generated SignedSource<<09dccad9e6c8f66d8bf585f6cc530afb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TableBody195BadPattern$data = {
  readonly aliases?: ReadonlyArray<string> | null | undefined;
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentSpreads": FragmentRefs<"RenderChildRowsComp856BadPattern">;
  readonly " $fragmentType": "TableBody195BadPattern";
};
export type TableBody195BadPattern$key = {
  readonly " $data"?: TableBody195BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"TableBody195BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "TableBody195BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "aliases"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "RenderChildRowsComp856BadPattern"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "9923e17006ebbac0a144056ef1cf537f";

export default node;
